import { Injectable } from "@angular/core";
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from "@ngrx/data";
import { IAnnounceList } from "../models/announcements.model";

@Injectable({
    providedIn: 'root'
})
export class AnnouncementsEntityService extends EntityCollectionServiceBase<IAnnounceList>{

    constructor(serviceElementsFactory:EntityCollectionServiceElementsFactory){
        super('Announcements', serviceElementsFactory);
    }

}